import { createFileRoute } from "@tanstack/react-router";
import { Card, PageHeader } from "../components/account-ui.tsx";
import { NotificationsList } from "../components/notifications/NotificationsList.tsx";

export const Route = createFileRoute("/account/notifications")({
  component: NotificationsPage,
});

function NotificationsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Notifications" subtitle="Artwork decisions and campaign alerts." />
      <Card bodyClass="p-5">
        <NotificationsList />
      </Card>
    </div>
  );
}
